import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

import {  Divider,Drawer, IconButton, List,Box,Modal,TextField,Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
// components


// styles
import useStyles from "./styles";

//newicons
import Dashboard from "./Icons/Dashboard";
import CallPanelIcon from "./Icons/CallPanelIcon";
import MenuIcon from "./Icons/MenuIcon";
import NotesIcon from '@material-ui/icons/SpeakerNotes';
import SpeakerNotesOutlinedIcon from '@material-ui/icons/SpeakerNotesOutlined';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';

import logo from "../../assets/images/logo.webp"

import SidebarLink from "./components/SidebarLink/SidebarLink";
import {
    localStorageFunc,
    //lowerCaseAllWordsExceptFirstLetters,
    //notify,
} from "../../helpers/utility";
// store
import * as actions from "../../store/actions/actionIndex";

const structure = [
	{ id: 0, label: "Dashboard", link: "/app/dashboard", icon: <Dashboard /> },
	{ id: 1, label: "Call Panel", link: "/app/callpanel", icon: <CallPanelIcon /> },
];
const style = {
	position: 'absolute',
	top: '50%',
	insetInlineStart: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 0,
  };
function Sidebar(props) {
	var location = props.location;
	var classes = useStyles();
	var theme = useTheme();

	const [open, setOpen] = React.useState(false);
	const [save, setSave] = useState(true);
	const [clear, setClear] = useState(true);
	const [notes, setNotes] = useState(props.notes);
	const handleClear = () => {
		setNotes('');
		onAgentNotes(agentId, '', 'save');
		setOpen(false)
		localStorageFunc.set("AgentNotes-"+props.agentId, notes);
	  };
	
	const handleSave = () => {
		onAgentNotes(agentId, notes, 'save');
		localStorageFunc.set("AgentNotes-"+props.agentId, notes);
	};
	
	const handleOpen = () => {
		setOpen(true);
		setNotes(localStorageFunc.get("AgentNotes-"+props.agentId));
	};
	const handleClose = () => setOpen(false);
	const {agentId, onAgentNotes} = props;
	// local
	var [isPermanent, setPermanent] = useState(true);
	//const [ShowChat,setShowChat] = useState(false);

	useEffect(function() {
		window.addEventListener("resize", handleWindowWidthChange);
		handleWindowWidthChange();
		return function cleanup() {
			window.removeEventListener("resize", handleWindowWidthChange);
		};
	});
	useEffect(
		() => {
		  onAgentNotes(agentId, '', '');
		},
		[agentId, onAgentNotes],
		[]
	  );
	const handleNotesClick = (value) => {
		if ((!value.match(/[^0-9a-zA-Z.!@&_=+:,?;|()#%\s-]+/g) && value.length < 501) || value === '') {
		  setClear(false);
		  setSave(false);
		  setNotes(value);
		} else {
		  alert('Only following special character allowed with maximum length 500 character.\n ! @ & - _ = + : , . ? ; | ( ) # %');
		}
	};

	const onToggleSidebar = (isSidebarOpened) => {
		props.onToggle(isSidebarOpened);
	};

	return (
		<Drawer
			variant="permanent"
			className={classNames(classes.drawer, {
				[classes.drawerOpen]: props.isSidebarOpened,
				[classes.drawerClose]: !props.isSidebarOpened,
			})}
			classes={{
				paper: classNames({
					[classes.drawerOpen]: props.isSidebarOpened,
					[classes.drawerClose]: !props.isSidebarOpened,
				}),
			}}
			open={props.isSidebarOpened}>
			{/* // arrr=ow back icon Start */}
			<IconButton color="inherit" onClick={() => onToggleSidebar(props.isSidebarOpened)} className={classNames(classes.headerMenuButton, classes.headerMenuButtonCollapse)}>
				{props.isSidebarOpened ? (
					<MenuIcon
						classes={{
							root: classNames(classes.headerIcon, classes.headerIconCollapse),
						}}
					/>
				) : (
					<MenuIcon
						classes={{
							root: classNames(classes.headerIcon, classes.headerIconCollapse),
						}}
					/>
				)}
			</IconButton>

			{/* ===== This button (closeSidebarMobile) is just for mobile view ===== */}
			
			<Box className={classes.closeSidebarMobile}>
				<img src={logo} alt="logo" width="120px" height="auto" />
			
				<IconButton onClick={() => onToggleSidebar(props.isSidebarOpened)} style={{marginBottom:"-10px"}}>
					<HighlightOffOutlinedIcon style={{fontSize:"1.75rem"}}/>
							</IconButton>
						</Box>
			<div className={classes.mobileBackButton}>
				<IconButton onClick={() => onToggleSidebar(props.isSidebarOpened)}>
					<MenuIcon
						classes={{
							root: classNames(classes.headerIcon, classes.headerIconCollapse),
						}}
					/>
				</IconButton>
			</div>
			<List className={classes.sidebarList}>
				{structure.map((link) => (
					<SidebarLink key={link.id} location={location} onToggleSidebar={onToggleSidebar} isSidebarOpened={props.isSidebarOpened} {...link} />
				))}
			</List>
		<div className={`${classes.NotesIconDiv} ${props.isSidebarOpened ? classes.NotesIconDivLg : classes.NotesIconDivSm}`}>
			<IconButton className={classes.NotesIcon} onClick={handleOpen} style={{width: props.isSidebarOpened ? "auto" : "58px"}}> 
				<SpeakerNotesOutlinedIcon style={{fontSize:"1.75rem"}}/>
			</IconButton>
			{ props.isSidebarOpened && <span className={classes.NotesLabel}>Notes</span> }
			</div>
			<Modal
				open={open}
				onClose={handleClose} 
				>
				<Box sx={style} >
					<div className={classes.ModalHeaderNotes}>
					Notes
					</div>
					<Divider light />
					
					<TextField fullWidth className={classes.TextFieldNotes}  id="outlined-textarea" rows={12} margin="dense" multiline variant="outlined" value={notes === '' ? props.notes : notes} onChange={(e) => handleNotesClick(e.target.value)} ></TextField>
					
					<Divider light />
					<div className={classes.ModalFooterNotes}>
						<Button color="primary" disabled={save} onClick={handleSave} variant="contained">Save</Button>
						<Button color="info" disabled={clear} onClick={handleClear}  variant="contained">Clear</Button>
					</div>
				</Box>
			</Modal>
		
		</Drawer>
		
	);

	function handleWindowWidthChange() {
		var windowWidth = window.innerWidth;
		var breakpointWidth = theme.breakpoints.values.md;
		var isSmallScreen = windowWidth < breakpointWidth;

		if (isSmallScreen && isPermanent) {
			setPermanent(false);
		} else if (!isSmallScreen && !isPermanent) {
			setPermanent(true);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		agentId: state.agentData.agentId,
		isSidebarOpened: state.layout.isSidebarOpened,
		notes: state.agentNotes.notes,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onToggle: (isSidebarOpened) => dispatch(actions.toggleSidebar(isSidebarOpened)),
		onAgentNotes: (agentId, notes, save) => dispatch(actions.agentNotes(agentId, notes, save)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
